import Util from '@/helper/Utility.js';

export function PointModel(dict) {
    if (!dict) return;

    this.caller = dict.Caller;
    this.campaignId = dict.CampaignId;
    this.campaignName = dict.CampaignName;
    this.createDate = dict.CreateDate;
    this.detail = Util.readJson(dict.Detail, dict.Detail);
    this.info = dict.Info;
    this.input = Util.readJson(dict.Input, dict.Input);
    this.message = Util.readJson(dict.Message, dict.Message);
    this.pair = dict.Pair;
    this.points = dict.Points;
    this.rowKey = dict.RowKey;
    this.timestamp = dict.Timestamp;
    this.type = dict.Type;
    this.userId = dict.UserId;
}
